import {ModalSubNav} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {StepsMap} from '../config';
import type {StepStatus} from '@/hooks';
import type {FC} from 'react';

export type ActivationPackageStepsNavProps = {
  items: StepsMap;
  value: string;
  onChange: (value: string) => void;
  statusMap?: Record<string, StepStatus>;
  /** Gates the error icons only — a locked step always shows its lock. */
  showErrors?: boolean;
};

export const ActivationPackageStepsNav: FC<ActivationPackageStepsNavProps> = ({
  items,
  value,
  onChange,
  statusMap,
  showErrors = true
}) => {
  const {t} = useTranslation('trustAccounts');

  const steps = Object.entries(items).map(([v, {labelKey}]) => {
    const label = t(labelKey);
    const isLocked = statusMap?.[v]?.isLocked === true;
    return {
      value: v,
      label,
      ariaLabel: isLocked ? t('activation.packageFormModal.lockedStep', {step: label}) : undefined,
      hasError: showErrors && statusMap?.[v]?.hasErrors === true,
      isLocked
    };
  });

  return <ModalSubNav items={steps} value={value} onChange={onChange} />;
};
